import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getWorkCalendarWorkTimeSaldoInformationInTimeframe = async (
  projectId,
  timeframe,
  activeEmployerInfo
) => {
  const { fromDate, toDate } = timeframe;

  const apiPath = `work-time-saldo/project/${projectId}/${fromDate}/${toDate}/work-calendar-saldo-information`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
